"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var MicrosoftSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10.0208179,2.99086097 L10.0208179,16.1345158 L2.9999918,14.5392655 L2.9999918,4.48097568 L10.0208179,2.99086097 Z M15,6 C15.5522847,6 16,6.44771525 16,7 L16,12 C16,12.5522847 15.5522847,13 15,13 L11,13 L11,12 L15,12 L15,8.238 L12.1192252,10.1660563 L11.0086368,9.48128836 L11,8.28345764 L12.097,8.977 L15,7.034 L15,7 L11,7 L11,6 L15,6 Z M6.59070986,6.99086097 C5.97405624,6.99086097 5.47868353,7.22710693 5.10459172,7.69905946 C4.73049991,8.171012 4.54373871,8.78913498 4.54373871,9.5534284 C4.54373871,10.2772687 4.72822234,10.864108 5.09605081,11.3150249 C5.46444868,11.7654025 5.940462,11.990861 6.52522955,11.990861 C7.12537075,11.990861 7.61163316,11.7578513 7.98458618,11.2929106 C8.35753919,10.8279699 8.5443004,10.2152407 8.54373871,9.45526227 C8.54373871,8.71578007 8.36380253,8.12031081 8.00394557,7.66831513 C7.644658,7.21631944 7.17319984,6.99086097 6.59070986,6.99086097 Z M6.56442836,7.99086097 C6.86787664,7.99086097 7.10677319,8.12463215 7.28166974,8.39217449 C7.45656629,8.66023533 7.54373871,9.0351057 7.54373871,9.51678562 C7.54373871,9.97876281 7.45325595,10.3401524 7.27339388,10.6004358 C7.09353181,10.8607193 6.84966974,10.990861 6.5423594,10.990861 C6.24442836,10.990861 6.00332491,10.8576083 5.81960078,10.5895475 C5.63587664,10.3220051 5.54373871,9.95802309 5.54373871,9.49760138 C5.54373871,9.04392008 5.63587664,8.67941956 5.81960078,8.40409983 C6.00332491,8.12878009 6.2521525,7.99086097 6.56442836,7.99086097 Z" })));
};
MicrosoftSmall.displayName = 'MicrosoftSmall';
exports.default = MicrosoftSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MicrosoftSmall.js.map